import background from "./Images/Oakmere_Background.png";
import NavBar from "./NavBar";
import "./LandingPage.css";

function LandingPage() {
  return (
    <div className="LandingPage">
      <NavBar />
      <div
        className="HeroSection"
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: "center 30%",
        }}
      >
        <div className="HeroOverlay"></div>
        <h1 className="HeroHeadline">Do Wealth Better.</h1>
      </div>
      <footer className="ComplianceFooter">
        <p>
          Oakmere Capital is a Juristic Representative of Yellowwood Private
          Wealth. Yellowwood Private Wealth is an authorised financial services
          provider.
        </p>
        <p>FSP No 49879</p>
        <p>
          Copies of our complaints and conflicts of interest policies are
          available upon request.
        </p>
      </footer>
    </div>
  );
}

export default LandingPage;
